import { Environment } from './environment.model';

export const environment: Environment = {
  name: 'PROD',
  enableSentry: true,
  coreDataHostUrl: 'https://avc-coredata.garmin.com',
  servicesHostUrl: 'https://avcloud-api.garmin.com',
  flyLegacyUrl: 'https://fly.garmin.com/fly-garmin',
  flyServiceUrl: 'https://fly.garmin.com/flyService',
  fgUrl: 'https://fg.garmin.com/',
  garminUrl: 'https://www.garmin.com',
  gatewayUrl: 'https://avcloud-gateway.garmin.com/webGateway',
  gatewayVersion1: 'v1',
  mapCapsUrl: 'https://fg.garmin.com/api/caps',
  trustArcSrc: 'https://consent.trustarc.com/notice?domain=garmin.com&c=teconsent&text=true',
  // All environments will be pointing to Sentry.io Prod
  sentryConfig: {
    dsn: 'https://1c6b518aa046e930d70792f2bab948bc@o430870.ingest.sentry.io/4505631102926848'
  },
  // All environments will be pointing to Tealium Prod
  tealiumConfig: {
    account: 'garmin',
    profile: 'main',
    environment: 'prod'
  },
  payFrameSrc: 'https://subscriptions.garmin.com/upc/js/min/payframe-upc.js',
  connectedDevicesEligibleForAircraftLogbook: [100]
};
